export class ProposalOrderReduced {
  constructor(
    public id: string,
    public number: number,
    public customerId: string,
    public customerName: string,
    public proposalStatus: number,
    public positionFunctions: PositionFunction[],
    public positionFunctionSubtotal: number,
    public materials: Material[],
    public materialsSubtotal: number,
    public recruitmentAndSelections: RecruitmentAndSelection[],
    public recruitmentAndSelectionsSubtotal: number,
    public total: number
  ) {}
}

export class PositionFunction {
  constructor(
    public quantity: number,
    public unitaryValue: number,
    public totalValue: number
  ) {}
}

export class Material {
  constructor(
    public quantity: number,
    public unitaryValue: number,
    public totalValue: number
  ) {}
}

export class RecruitmentAndSelection {
  constructor(
    public quantity: number,
    public unitaryValue: number,
    public totalValue: number
  ) {}
}
